/**
 * @generated SignedSource<<1b4f02e7263ffdbf99d8f7524bb6fd9f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FullPageEditorComponentReadFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly contentId: string;
    readonly macroId: string;
    readonly renderedMacro: {
      readonly macroBodyStorage: string | null | undefined;
      readonly macroRenderedRepresentation: ContentRepresentationV2 | null | undefined;
      readonly mediaToken: {
        readonly token: string | null | undefined;
      } | null | undefined;
      readonly value: string | null | undefined;
      readonly webResource: {
        readonly contexts: ReadonlyArray<string | null | undefined>;
        readonly keys: ReadonlyArray<string | null | undefined>;
        readonly superbatch: {
          readonly metatags: string | null | undefined;
        } | null | undefined;
        readonly tags: {
          readonly css: string | null | undefined;
          readonly data: string | null | undefined;
          readonly js: string | null | undefined;
        } | null | undefined;
        readonly uris: {
          readonly css: ReadonlyArray<string | null | undefined> | null | undefined;
          readonly data: ReadonlyArray<string | null | undefined> | null | undefined;
          readonly js: ReadonlyArray<string | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly endCursor: string | null | undefined;
    readonly hasNextPage: boolean;
  };
  readonly " $fragmentType": "FullPageEditorComponentReadFragment";
};
export type FullPageEditorComponentReadFragment$key = {
  readonly " $data"?: FullPageEditorComponentReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FullPageEditorComponentReadFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FullPageEditorComponentReadFragment",
  "selections": [
    {
      "concreteType": "Macro",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "macroId"
        },
        {
          "kind": "ScalarField",
          "name": "contentId"
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "mode",
              "value": "EDITOR"
            }
          ],
          "concreteType": "RenderedMacro",
          "kind": "LinkedField",
          "name": "renderedMacro",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "macroRenderedRepresentation"
            },
            {
              "kind": "ScalarField",
              "name": "macroBodyStorage"
            },
            {
              "concreteType": "WebResourceDependenciesV2",
              "kind": "LinkedField",
              "name": "webResource",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "contexts"
                },
                {
                  "kind": "ScalarField",
                  "name": "keys"
                },
                {
                  "concreteType": "SuperBatchWebResourcesV2",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "metatags"
                    }
                  ]
                },
                {
                  "concreteType": "WebResourceTagsV2",
                  "kind": "LinkedField",
                  "name": "tags",
                  "plural": false,
                  "selections": (v0/*: any*/)
                },
                {
                  "concreteType": "WebResourceUrisV2",
                  "kind": "LinkedField",
                  "name": "uris",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            },
            {
              "concreteType": "EmbeddedMediaTokenV2",
              "kind": "LinkedField",
              "name": "mediaToken",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "token"
                }
              ]
            }
          ],
          "storageKey": "renderedMacro(mode:\"EDITOR\")"
        }
      ]
    },
    {
      "concreteType": "PageInfoV2",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        }
      ]
    }
  ],
  "type": "MacroConnection"
};
})();

(node as any).hash = "9c9352ccf1b8c8a448af05f4d82f86d8";

export default node;
